import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=eb132c70&"
import script from "./Size.vue?vue&type=script&lang=js&"
export * from "./Size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports